<template>
    <div class="segment-summary">
        <header class="font-3">
            Other
            <IconBase
                iconName="lockIcon"
                :iconColor="consts.COLORS.LIGHT_700"
                width="10"
                height="13"
            />
        </header>
        <div class="segment-summary-row" v-for="(placements, adUnitId) in listData" :key="adUnitId">
            <div>
                <AdUnitTitle
                    v-if="adUnitId"
                    :adUnit="getAdUnitNameById(adUnitId)"
                />
            </div>
            <div>
                <button @click.prevent="showPlacements(adUnitId)"
                        class="placements-link button-linkStyle">
                    {{ placements.length }} Placements &raquo;
                </button>
            </div>
        </div>
        <div v-if="disabled" class="disabled-overlay" />
    </div>
</template>

<script>
import consts from 'services/metaData/consts';
import AdUnitTitle from 'components/AdUnitTitle.vue';
import { invert, mapValues, pick } from 'lodash';
import IconBase from 'components/IconBase.vue';
import { adUnitIds } from 'services/utils/adUnitsMap';

export default {
    name: 'SegmentSummary',
    components: { IconBase, AdUnitTitle },
    props: {
        placementsData: {
            type: Object,
            required: true
        },
        supportedAdUnits: {
            type: Array,
            default: () => [],
            validator: (value) => value.every((adUnit) => Object.keys(consts.ADUNIT_TO_NAME).includes(adUnit))
        },
        disabled: Boolean
    },
    computed: {
        listData() {
            const supportedIds = this.supportedAdUnits.map((a) => adUnitIds[a]);
            const notArchived = mapValues(this.placementsData, (placements) => placements.filter((p) => !p.archived));
            return pick(notArchived, supportedIds);
        },
        consts: () => consts
    },
    methods: {
        getAdUnitNameById(adUnitId) {
            const names = invert(adUnitIds);
            return names[adUnitId] || '';
        },
        showPlacements(adUnitId) {
            const adUnitName = this.getAdUnitNameById(adUnitId);
            this.$emit('showPlacements', adUnitName);
        }
    }
};
</script>

<style lang="scss" scoped>
@import "~styles/styleGuide.scss";
@import "~styles/buttons.scss";

.segment-summary {
    margin-left: 25px;
    margin-bottom: 20px;
    border: $border;
    border-radius: $borderRadius;
}

header {
    color: $light-800;
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 50px;
    border-bottom: $border;
    padding: 0 12px 0 15px;
}

.segment-summary-row {
    display: grid;
    grid-template-columns: 1fr 2fr;
    grid-auto-rows: 43px;
    grid-column-gap: 3px;
    align-items:center;
    border-bottom: $border;
    padding: 0 18px;
    &:last-child {
        border-bottom: none;
    }
}

.placements-link {
    font-weight: normal;
    &:active {
        font-weight: normal;
    }
}

.disabled-overlay {
    position: absolute;
    z-index: 15;
    background: $white;
    opacity: 0.4;
    top: 0;
    bottom: 0;
    right: 0;
    left: 0;
}
</style>
